var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_240)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 51.875H57.75C56.7559 51.8765 55.8029 52.2721 55.1 52.975C54.3971 53.6779 54.0015 54.6309 54 55.625V66.875C54.0015 67.8691 54.3971 68.8221 55.1 69.525C55.8029 70.2279 56.7559 70.6235 57.75 70.625H65.25V66.875H57.75V55.625H76.5V66.875H71.7469L66.8831 74.1687L70.0031 76.25L73.7531 70.625H76.5C77.4941 70.6235 78.4471 70.2279 79.15 69.525C79.8529 68.8221 80.2485 67.8691 80.25 66.875V55.625C80.2485 54.6309 79.8529 53.6779 79.15 52.975C78.4471 52.2721 77.4941 51.8765 76.5 51.875ZM40.2506 65.2044L41.865 63.5881C42.0809 63.3713 42.356 63.2229 42.6558 63.1615C42.9556 63.1001 43.2669 63.1285 43.5506 63.2431L45.5194 64.0306C45.8093 64.146 46.0578 64.346 46.2327 64.6044C46.4076 64.8629 46.5007 65.1679 46.5 65.48V69.0575C46.5006 69.2702 46.4577 69.4808 46.374 69.6764C46.2903 69.872 46.1675 70.0484 46.0132 70.1948C45.8588 70.3412 45.6762 70.4546 45.4765 70.5279C45.2768 70.6012 45.0643 70.633 44.8519 70.6212C31.0631 69.7644 28.2769 58.085 27.7613 53.6113C27.7364 53.3927 27.758 53.1714 27.8248 52.9618C27.8915 52.7522 28.0018 52.5591 28.1484 52.3952C28.295 52.2312 28.4746 52.1001 28.6754 52.0105C28.8763 51.9208 29.0938 51.8746 29.3138 51.875H32.8275C33.1401 51.8741 33.4457 51.9673 33.7046 52.1425C33.9634 52.3178 34.1635 52.5669 34.2787 52.8575L35.0662 54.8262C35.1804 55.1098 35.2086 55.4206 35.1473 55.7201C35.0859 56.0195 34.9377 56.2942 34.7212 56.51L33.105 58.1244C33.3865 59.9114 34.2313 61.5619 35.5163 62.8354C36.8012 64.1089 38.4611 64.9389 40.2506 65.2044ZM63.375 36.875H76.5V40.625H63.375V36.875ZM63.375 29.375H80.25V33.125H63.375V29.375ZM55.875 31.25L50.25 35.375V31.25C50.25 30.2554 49.8549 29.3016 49.1516 28.5983C48.4484 27.8951 47.4946 27.5 46.5 27.5H31.5C30.5054 27.5 29.5516 27.8951 28.8483 28.5983C28.1451 29.3016 27.75 30.2554 27.75 31.25V42.5C27.75 43.4946 28.1451 44.4484 28.8483 45.1516C29.5516 45.8549 30.5054 46.25 31.5 46.25H46.5C47.4946 46.25 48.4484 45.8549 49.1516 45.1516C49.8549 44.4484 50.25 43.4946 50.25 42.5V38.375L55.875 42.5V31.25ZM31.5 42.5V31.25H46.5V42.5H31.5Z",
    fill: "#5f9098"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_240",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_240",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationSystem);
export default __webpack_public_path__ + "static/media/communicationSystem.cdb78fbc5f21c7c638b20505c7f58b9b.svg";
export { ForwardRef as ReactComponent };